import {
  string,
  shape
} from 'prop-types';

export default shape({
  name: string,
  email: string,
  emailConfirm: string,
  phone: string,
  comment: string
});



// WEBPACK FOOTER //
// ./src/utils/shapes/OrderDetails.js